/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
							this.parent.classList.add('active');
						}
					}
          // Cards now exist in the DOM — initialize them
          this.dispatchEvent(new CustomEvent('recommendations:loaded', { bubbles: true }));
				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);

function initRecommendationCards(scope) {
  var root = scope || document;
  var productCards = root.querySelectorAll('.product-card-selector');

  productCards.forEach(card => {
    if (card.dataset.cardInit) return; // avoid double-binding
    card.dataset.cardInit = 'true';

    const variantSelect = card.querySelectorAll('.product-variants-selector');
    const productImage = card.querySelector('.product-image-selector');
    const productPrice = card.querySelector('.product-price-selector');
    const addToCartButton = card.querySelector('.custom-add-to-cart');
    let selectedVariant = 0;
    let first_available_variant = false;

    variantSelect.forEach(variant => {
      if (variant.hasAttribute('data-variant-id') && first_available_variant == false) {
        selectedVariant = variant.getAttribute('data-variant-id');
        variant.classList.add('selected-variant');
        first_available_variant = true;
      }

      variant.addEventListener('click', event => {
        variantSelect.forEach(v => v.classList.remove('selected-variant'));
        const imageUrl = variant.getAttribute('data-image');
        const price = variant.getAttribute('data-price');
        variant.classList.add('selected-variant');

        if (imageUrl) {
          productImage.src = imageUrl;
          productImage.srcset = imageUrl;
        }
        if (price) {
          productPrice.textContent = price;
        }

        selectedVariant = variant.getAttribute('data-variant-id');
        addToCartButton.setAttribute('data-variant-id', variant.getAttribute('data-variant-id'));
      });
    });

    if (addToCartButton) {
      addToCartButton.addEventListener('click', function () {
        const variantId = selectedVariant;
        if (variantId) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(response => response.json())
            .then(data => { console.log('Item added to cart'); })
            .catch(error => { console.error('Error adding item to cart', error); })
            .finally(() => {
              addToCartButton.classList.remove('is-loading');
              addToCartButton.disabled = false;
            });
        } else {
          addToCartButton.classList.remove('is-loading');
          addToCartButton.disabled = false;
        }
      });
    }
  });
}

// Init when recommendations inject their cards (any speed)
document.addEventListener('recommendations:loaded', function (e) {
  initRecommendationCards(e.target);
});

// Also init any cards already present on load (non-recommendation contexts)
document.addEventListener('DOMContentLoaded', function () {
  initRecommendationCards(document);
});
